import { IMEventBus } from "lib/mp-stjk-im-service";

module.exports = Behavior({
    behaviors: [],
    properties: {},
    data: {},
    ready: function() {
        this.handleMsgContainerReset();
    },
    detached: function() {
        IMEventBus.trigger(
            "RESET_FOOTER_CONTAINER_HEIGHT",
            0
        );
    },
    methods: {
        handleContainerReset: function(event) {
            const keyboardHeight =
                (event && event.detail && event.detail.height) || 0;
            if (this.cmpHeight) {
                let footerHeight = this.cmpHeight + keyboardHeight;
                IMEventBus.trigger(
                    "RESET_FOOTER_CONTAINER_HEIGHT",
                    footerHeight,
                    this.data.isControlPanel,
                    keyboardHeight
                );
            }
        },
        handleMsgContainerReset(event) {
            wx.createSelectorQuery()
                .in(this)
                .select(".footer-container")
                .boundingClientRect(res => {
                    if (res && res.height) {
                        this.cmpHeight = res.height;
                        this.handleContainerReset(event);
                    }
                })
                .exec();
        }
    }
});
